import type { FunctionComponent } from 'react';

import { ProgressCircleOutline } from './ProgressCircleOutline';

const radius = 8.914;
const strokeWidth = 2;
const circleLength = Math.PI * radius * 2;

export const PersonProgressIcon: FunctionComponent<{
    readonly colorBase: string;
    readonly colorFill: string;
    readonly isActive: boolean;
    readonly progress: number;
}> = ({ colorBase, colorFill, isActive, progress }) => {
    const dashLength = circleLength * progress;

    return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
        <svg fill="none" height="14" viewBox="0 0 24 24" width="14" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r={radius} stroke={colorBase} strokeWidth={strokeWidth} />
            <ProgressCircleOutline
                circleLength={circleLength}
                cx="12"
                cy="12"
                dashLength={dashLength}
                isActive={isActive}
                radius={radius}
                strokeWidth={strokeWidth}
                transform="rotate(-90 12 12)"
            />
            <circle
                cx="12"
                cy="12"
                r={radius}
                stroke={colorFill}
                strokeDasharray={`${dashLength} ${circleLength}`}
                strokeLinecap="round"
                strokeWidth={strokeWidth}
                transform="rotate(-90 12 12)"
            />
            <path
                d="M7.286 17V16.143C7.286 14.881 8.307 13.857 9.571 13.857H14.429C15.693 13.857 16.714 14.881 16.714 16.143V17M14.714 9.714C14.714 11.643 13.5 12.429 12 12.429C10.5 12.429 9.286 11.643 9.286 9.714C9.286 7.786 10.5 7.571 12 7.571C13.5 7.571 14.714 7.786 14.714 9.714Z"
                stroke={colorBase}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            />
        </svg>
    );
};
